import { createContext, ReactNode, useContext } from 'react';

type SideNavigationContextType = {
  isCollapsed: boolean;
};

const SideNavigationContext = createContext<SideNavigationContextType | undefined>(undefined);

type SideNavigationProviderProps = {
  isCollapsed: boolean;
  children: ReactNode;
};

export function SideNavigationProvider({ isCollapsed, children }: SideNavigationProviderProps) {
  return (
    <SideNavigationContext.Provider value={{ isCollapsed }}>
      {children}
    </SideNavigationContext.Provider>
  );
}

export function useSideNavigation() {
  const context = useContext(SideNavigationContext);
  if (!context) {
    throw new Error('useSideNavigation must be used within a SideNavigationProvider');
  }
  return context;
}
